import React, { useEffect, useState } from "react";
import {
  Box,
  SimpleGrid,
  Image,
  Text,
  Input,
  Button,
  InputGroup,
  InputRightElement,
  VStack,
  Container,
  HStack,
} from "@chakra-ui/react";
import draftimage from "../../Assets/lawsImage/draft.jpg";
import { Link } from "react-router-dom";
import axios from "axios";
import * as mod from "../../../url";
import LAWVSLoader from "../../../utils/Loders";

export default function DraftsGrid() {
  const [allDrafts, setAllDrafts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const draftsPerPage = 12; // Number of drafts per page

  // Fetch drafts from API
  const fetchAllDrafts = async () => {
    setLoading(true);
    const startTime = Date.now();

    try {
      const { data } = await axios.get(
        `${mod.api_url}/api/v1/draft/get_active_drafts`
      );
      setAllDrafts(data);
    } catch (error) {
      console.error("Error fetching drafts:", error);
    } finally {
      const elapsed = Date.now() - startTime;
      const remaining = Math.max(1000 - elapsed, 0); // ensure minimum 1s
      setTimeout(() => setLoading(false), remaining);
    }
  };

  useEffect(() => {
    fetchAllDrafts();
  }, []);

  // Filter drafts by title
  const filteredDrafts = allDrafts.filter((draft) =>
    draft.subTitle.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Pagination logic
  const indexOfLastDraft = currentPage * draftsPerPage;
  const indexOfFirstDraft = indexOfLastDraft - draftsPerPage;
  const currentDrafts = filteredDrafts.slice(
    indexOfFirstDraft,
    indexOfLastDraft
  );

  const totalPages = Math.ceil(filteredDrafts.length / draftsPerPage);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };
  if (loading) {
    return <LAWVSLoader />;
  }
  return (
    <Container maxW="7xl" py={12}>
      {/* Search Bar */}
      <InputGroup size="lg" mb={8}>
        <Input
          placeholder="Search drafts by name"
          borderRadius="md"
          borderColor="gray.300"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
        <InputRightElement width="5rem">
          <Button h="100%" colorScheme="blue" borderRadius="md">
            Search
          </Button>
        </InputRightElement>
      </InputGroup>

      {/* Drafts Cards */}
      {currentDrafts.length === 0 ? (
        <Box textAlign="center" py={20}>
          <Text fontSize="xl" color="gray.500">
            No drafts found matching your search.
          </Text>
        </Box>
      ) : (
        <SimpleGrid columns={{ base: 1, sm: 2, md: 3 }} spacing={8}>
          {currentDrafts.map((d, i) => (
            <Box
              key={i}
              borderWidth="1px"
              borderRadius="md"
              overflow="hidden"
              as={Link}
              to={`/drafts/${d.slug}`}
              p={4}
              boxShadow="md"
            >
              <VStack
                spacing={4}
                color="white"
                _hover={{
                  textDecoration: "none",
                  cursor: "pointer",
                  backgroundColor: "gray.50",
                }}
              >
                <Image
                  src={draftimage}
                  alt="Draft"
                  boxSize="80px"
                  objectFit="contain"
                />
                <Box
                  bg="blue.300"
                  color="white"
                  p={3}
                  textAlign="center"
                  borderRadius="md"
                  fontWeight="semibold"
                  fontSize="sm"
                  lineHeight="short"
                >
                  <Text noOfLines={3}>{d.title.toUpperCase()}</Text>
                </Box>
              </VStack>
            </Box>
          ))}
        </SimpleGrid>
      )}

      {/* Pagination Controls */}
      {totalPages > 1 && (
        <HStack justify="center" mt={8} spacing={4}>
          <Button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Previous
          </Button>
          {Array.from({ length: totalPages }, (_, i) => (
            <Button
              key={i + 1}
              colorScheme={currentPage === i + 1 ? "blue" : "gray"}
              onClick={() => handlePageChange(i + 1)}
            >
              {i + 1}
            </Button>
          ))}
          <Button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            Next
          </Button>
        </HStack>
      )}
    </Container>
  );
}
